module.exports = __webpack_public_path__ + "img/banner2-1@1x.a8c2d4e3.jpg";